/* Where students get the extension and the phone app, and which one fits the device they're on.
   The store links are set at build time once the listings exist (build.mjs; docs/SETUP.md §8): EXTENSION_STORE_URL,
   IOS_APP_URL and ANDROID_APP_URL. Until then they are empty and the pages say "coming soon". */
declare const __STORES__: { chrome: string; ios: string; android: string } | undefined;
export const STORES: { chrome: string; ios: string; android: string } =
  typeof __STORES__ !== 'undefined' && __STORES__ ? __STORES__ : { chrome: '', ios: '', android: '' };

/* app: the PathsAbroad phone app (it opens portals inside itself, no extension needed);
   chromium: a desktop browser that installs from the Chrome Web Store (Chrome, Edge, Brave, Opera, Arc…);
   phone: a phone or tablet browser; other: a desktop browser without Chrome extensions (Safari, Firefox) */
export type Device = 'app' | 'chromium' | 'phone' | 'other';

type Nav = { userAgent?: string; userAgentData?: { brands?: Array<{ brand: string }>; mobile?: boolean }; maxTouchPoints?: number };
type Win = { Capacitor?: { isNativePlatform?: () => boolean } };

export function deviceKind(nav: Nav = globalThis.navigator ?? {}, win: Win = globalThis as Win): Device {
  try { if (win.Capacitor?.isNativePlatform?.()) return 'app'; } catch { /* not the app */ }
  const ua = nav.userAgent ?? '';
  const iPadOs = /Macintosh/.test(ua) && (nav.maxTouchPoints ?? 0) > 1;
  if (nav.userAgentData?.mobile || /Android|iPhone|iPad|iPod|Mobile/i.test(ua) || iPadOs) return 'phone';
  const brands = nav.userAgentData?.brands?.map(b => b.brand) ?? [];
  if (brands.some(b => /Chromium|Google Chrome|Microsoft Edge/.test(b))) return 'chromium';
  if (/\bChrome\/\d+/.test(ua) && !/\bFirefox\//.test(ua)) return 'chromium';
  return 'other';
}

/* the phone app's store for this phone: the App Store on iPhone and iPad, Google Play on everything else */
export function phoneStore(nav: Nav = globalThis.navigator ?? {}): 'ios' | 'android' {
  const ua = nav.userAgent ?? '';
  return /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && (nav.maxTouchPoints ?? 0) > 1) ? 'ios' : 'android';
}
